

































import useTemplates from "@/composables/v3/useTemplates";
import { defineComponent, nextTick, ref } from "@vue/composition-api";
import { BTab, BTabs } from "bootstrap-vue";
import ApprovedMedia from "./approvedMedia.vue";
import ApprovedText from "./approvedText.vue";
import ManageMediaTemplate from "./manageMediaTemplate.vue";
import ManageTemplate from "./manageTemplate.vue";
import Variables from "./variables.vue";

export default defineComponent({
    components: {
        BTabs,
        BTab,
        ApprovedText,
        ApprovedMedia,
        ManageTemplate,
        ManageMediaTemplate,
        Variables,
    },
    setup() {
        const {
            fetchVariablesFromContent,
            isManageTemplatePanelActive,
            selectedTemplate,
            resetTemplate,
            showMediaTemplateManager,
        } = useTemplates();
        const activeTab = ref(0);

        const manageTemplate = () => {
            isManageTemplatePanelActive.value = true;
        };

        // Media template management
        //const mediaTemplate = ref({});

        const openMediaTemplateManager = async (template) => {
            //mediaTemplate.value = template;
            selectedTemplate.value = template;
            showMediaTemplateManager.value = true;
        };

        const closeMediaTemplateManager = () => {
            showMediaTemplateManager.value = false;

            nextTick(() => {
                activeTab.value = 1;
            });
        };

        return {
            resetTemplate,
            selectedTemplate,
            isManageTemplatePanelActive,

            // Methods
            fetchVariablesFromContent,
            manageTemplate,

            // Media template management
            showMediaTemplateManager,
            openMediaTemplateManager,
            closeMediaTemplateManager,
            //mediaTemplate,

            activeTab,
        };
    },
});
